import { render, staticRenderFns } from "./Farms.vue?vue&type=template&id=5bd48098&scoped=true"
import script from "./Farms.vue?vue&type=script&lang=js"
export * from "./Farms.vue?vue&type=script&lang=js"
import style0 from "./Farms.vue?vue&type=style&index=0&id=5bd48098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd48098",
  null
  
)

export default component.exports